import styled from 'styled-components';

export const TriggerButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 2px;
  border: none;
  border-radius: 4px;
  background: transparent;
  color: #64748b;
  cursor: pointer;
  line-height: 0;

  &:hover {
    background: #e2e8f0;
    color: #1e293b;
  }

  &:focus-visible {
    outline: 2px solid #2563eb;
    outline-offset: 1px;
  }
`;

const COLUMN_WIDTH = 240;
const SINGLE_COLUMN_WIDTH = 380;

export const Card = styled.div<{ $columns: number }>`
  position: fixed;
  z-index: 10000;
  /* sem isto o max-height limita só a caixa de conteúdo e o cartão fica 26px maior. */
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  width: ${(props) => SINGLE_COLUMN_WIDTH + (props.$columns - 1) * COLUMN_WIDTH}px;
  max-width: calc(100vw - 16px);
  /* um script de 30 etapas passa de 780px: sem o teto, o fim da lista fica fora da tela
     e é inalcançável, porque o cartão é fixed e não entra no scroll da página. */
  max-height: 70vh;
  padding: 12px 14px;
  background: #fff;
  border: 1px solid #cbd5e1;
  border-radius: 6px;
  box-shadow: 0 4px 16px rgba(15, 23, 42, 0.16);
  font-family: 'Inter', sans-serif;
  cursor: default;
`;

export const Header = styled.div`
  display: flex;
  flex-shrink: 0;
  align-items: flex-start;
  gap: 8px;
`;

export const Name = styled.span`
  flex: 1;
  min-width: 0;
  font-size: 0.75rem;
  font-weight: 700;
  color: #1e293b;
  line-height: 1.25;
  word-break: break-word;
`;

export const Chip = styled.span`
  flex-shrink: 0;
  padding: 2px 6px;
  border-radius: 4px;
  background: #f1f5f9;
  font-size: 0.75rem;
  color: #475569;
  white-space: nowrap;
`;

export const CloseButton = styled.button`
  flex-shrink: 0;
  display: inline-flex;
  padding: 2px;
  border: none;
  border-radius: 4px;
  background: transparent;
  color: #94a3b8;
  cursor: pointer;
  line-height: 0;

  &:hover {
    background: #f1f5f9;
    color: #1e293b;
  }

  &:focus-visible {
    outline: 2px solid #2563eb;
    outline-offset: 1px;
  }
`;

export const Divider = styled.div`
  flex-shrink: 0;
  height: 1px;
  margin: 10px 0;
  background: #e2e8f0;
`;

export const Counts = styled.div`
  display: flex;
  flex-shrink: 0;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 12px;
`;

export const StageList = styled.ol<{ $columns: number }>`
  margin: 0;
  padding: 0 4px 0 0;
  list-style: none;
  /* o rótulo mais longo tem ~22 caracteres e sobrava metade da largura em branco: o cartão abre
     uma coluna nova à direita a cada bloco de etapas, e cada coluna enche de cima para baixo. */
  column-count: ${(props) => props.$columns};
  column-gap: 24px;
  /* só as etapas rolam: nome, id e contagens ficam sempre à vista.
     min-height: 0 é o que permite um filho de flex encolher abaixo do conteúdo. */
  min-height: 0;
  overflow-y: auto;
`;

export const Stage = styled.li`
  display: flex;
  gap: 8px;
  margin-bottom: 6px;
  font-size: 0.8rem;
  color: #334155;
  line-height: 1.35;
  /* uma etapa não pode ficar partida entre o fim de uma coluna e o topo da outra. */
  break-inside: avoid;
`;

export const StageNumber = styled.span`
  flex-shrink: 0;
  width: 18px;
  color: #94a3b8;
  font-variant-numeric: tabular-nums;
`;

export const EmptyMessage = styled.p`
  margin: 0;
  font-size: 0.8rem;
  color: #94a3b8;
  font-style: italic;
`;
